import { inject, Injectable } from "@angular/core";
import { AuthService } from "../auth/auth.service";
import { GlobalStorageService } from "../global-storage/global-storage.service";
import { OldStorage } from "@core/enums/old-storage.enum";
import { CustomToastService } from "../custom-toast/custom-toast.service";

@Injectable({
  providedIn: "root",
})
export class SessionCleanupService {
  private keysToDelete: string[] = [
    OldStorage.ID,
    OldStorage.FIRST_NAME,
    OldStorage.LAST_NAME,
    OldStorage.USER_DEMO,
    OldStorage.USER_ROLE,
    OldStorage.COMPANY_ID,
    OldStorage.AVATAR_TUTOR,
    OldStorage.TIME_RESULT,
    OldStorage.RESULT,
    OldStorage.POINTS,
    OldStorage.RECENTLY_STARTED_COURSE,
  ];

  private readonly authService: AuthService = inject(AuthService);
  private readonly globalStorage: GlobalStorageService = inject(GlobalStorageService);
  private readonly toastService: CustomToastService = inject(CustomToastService);

  public async cleanupSessions(): Promise<void> {
    try { 
      await this.authService.logout();
      const keysToDelete: string[] = this.keysToDelete;
      keysToDelete.forEach((key) => this.globalStorage.delete(key));

    } catch(_error) {
      this.toastService.show({ message: "Error al limpiar sesiones", type: "error" });
    }
  }

}
